import { Box } from '@material-ui/core';
import logo from '../images/logo-white.png';


const SlashScreen = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.paper',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
     <img style={{width:"120px"}} src={logo}></img>
  </Box>
);

export default SlashScreen;
